export class Constant {
  // static apiAdress = 'http://dba7bbdbaee9.ngrok.io';
  // static apiAdress = 'https://157.245.244.21:8084';
  static apiAdress = 'https://kebabish.ranecs.com';
}
